<div class="page">
    <div class="page-name">Manage Publish/Distribution</div><br>
    <div class="row"  *ngIf="isSuperAdmin">
        <div class="col-12 col-lg-6">
            <div class="rollback-sec">

                <div class="card-title">Weekending date maintenance</div>

                <ng-container *ngIf="loadingWeekendingRollback">
                    <div class="skeleton skeleton-table-row" style="height: 150px;"></div>
                </ng-container>

                <div class="weekending-body" *ngIf="!loadingWeekendingRollback">
                    <div class="weekending-label">Current Weekending Date</div>
                    <dx-date-box [readOnly]="disAdmin" class="weekending-dt" type="date" #currentWeekendControl="ngModel" displayFormat="MM/dd/yy" 
                        [ngModel]="currentWeekendingDt" [readOnly]="true" stylingMode="outlined">
                    </dx-date-box>
                    <dx-button [disabled]="disAdmin" class="rounded-pill wk-option-btn" *ngIf="!rollbackStatus" stylingMode="contained"
                        text="Rollback" type="default" (onClick)="confirmRollback()">
                    </dx-button>
                    <dx-button [disabled]="disAdmin" class="rounded-pill wk-option-btn" *ngIf="rollbackStatus" stylingMode="contained"
                        text="Roll Forward" type="default" (onClick)="confirmRollforward()">
                    </dx-button>
                </div>
            </div>
        </div>
    </div>

    <div class="section" *ngIf="PSRGroupsDataSource">

        <div class="content-block pt-1" *ngIf="showPublish">

            <div class="section-title">Publish PSR</div>

            <div class="d-flex mt-2 mb-4 gap-4">

                <div>
                    <dx-button class="popOverBtn rounded-pill" [disabled]="disAdmin || disPublish" id="publish" (onClick)="ckeckPublish()"
                        stylingMode="contained" text="Publish" type="default">
                    </dx-button>
                    <dx-popover position="bottom" [width]="235" [height]="'auto'" [target]="'#publish'"
                        [shading]="true"  [shadingColor]="'rgba(0,0,0,0.3)'" [wrapperAttr]="{ class: 'popoverWrap' }" [(visible)]="showPublishPopup" [showTitle]="true"
                        titleTemplate="titleTemplate"  [toolbarItems]="publishPopoverToolbarItems"
                        >
                        <div *dxTemplate="let data of 'titleTemplate'" class="popover-title">
                            <div class="popover-title-text">Report Names</div>
                        </div>
                        <div *dxTemplate="let data of 'content'">
                            <dx-list 
                                #publisherListDropdown [dataSource]="PSRGroupsDataSource" [height]="'100%'"
                                [selectionMode]="'all'"
                                [selectAllMode]="'page'"(onSelectionChanged)="onSelectionChange($event,'publish')"
                                [showSelectionControls]="true" displayExpr="psrGroupName"
                                [selectedItems]="selectedPublishGroups">
                            </dx-list>
                        </div>
                        <!-- <dxi-toolbar-item widget="dxButton" location="before"
                            [options]="{text: 'Publish', type: 'default', stylingMode: 'contained', onClick: confirmPublish,
                            elementAttr: { class: 'rounded-pill', id: popupType }}" toolbar="bottom">
                        </dxi-toolbar-item> -->
                    </dx-popover>
                </div>
                
                <div>
                    <dx-button class="popOverBtn rounded-pill" [disabled]="disAdmin || disPublish" id="revoke" (onClick)="checkRevoke()"
                        stylingMode="contained" text="Revoke" type="default">
                    </dx-button>
                    <dx-popover position="bottom" [width]="235" [height]="'auto'" [target]="'#revoke'"
                        [shading]="true" [wrapperAttr]="{ class: 'popoverWrap' }" [(visible)]="showRevokePopup" [showTitle]="true"
                        titleTemplate="titleTemplate" [toolbarItems]="revokePopoverToolbarItems"
                        >
                        <div *dxTemplate="let data of 'titleTemplate'" class="popover-title">
                            <div class="popover-title-text">Report Names</div>
                        </div>
                        <div *dxTemplate="let data of 'content'">
                            <dx-list 
                                #publisherListDropdown [dataSource]="PSRGroupsDataSource" [height]="'100%'"
                                [selectionMode]="'all'"
                                [selectAllMode]="'page'" (onSelectionChanged)="onSelectionChange($event,'revoke')"
                                [showSelectionControls]="true" displayExpr="psrGroupName"
                                [selectedItems]="selectedRevokeGroups">
                            </dx-list>
                        </div>
                        <!-- <dxi-toolbar-item widget="dxButton" location="before"
                            [options]="{text: 'Revoke', type: 'default', stylingMode: 'contained', onClick: confirmRevoke, disabled: !selectedRevokeGroups.length,
                            elementAttr: { class: 'rounded-pill', id: popupType }}" toolbar="bottom">
                        </dxi-toolbar-item> -->
                    </dx-popover>
                </div>

            </div>

            <div class="d-flex w-100 flex-fill flex-row">
                <dx-data-grid
                    #publish_grid 
                    class="grid-with-header"
                    [dataSource]="publishListData"
                    [allowColumnResizing]="true" 
                    [columnResizingMode]="'widget'" 
                    [hoverStateEnabled]="true"
                    [rowAlternationEnabled]="true" 
                    [columnAutoWidth]="true" 
                    [allowColumnReordering]="true"
                    noDataText="No records found!"
                >
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-paging [pageSize]="20" [pageIndex]="0"> </dxo-paging>
                    <dxo-pager
                        [visible]="publishListData.length>0"
                        [allowedPageSizes]="[20, 30, 50]"
                        [showPageSizeSelector]="true"
                        [showInfo]="true"
                        [showNavigationButtons]="true"
                    ></dxo-pager>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    *ngIf="publishListData.length"
                                    icon="exportxlsx"
                                    hint="Excel Export"
                                    (click)="onExporting($event)"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item name="columnChooserButton"></dxi-item>
                    </dxo-toolbar>
                    <ng-container *ngFor="let column of displayColumns">
                        <dxi-column [dataField]="column.dataField" [dataType]="column.dataType"
                            [caption]="column.caption" [format]="column.format" [width]="column.width">
                        </dxi-column>
                    </ng-container>

                </dx-data-grid>
            </div>

        </div>

        <app-confirmation-popup *ngIf="openConfirmationPopup" [option]="confirmationPopupOption"
            (onConfirmed)="confirmationChanges($event)"></app-confirmation-popup>
    </div>
</div>
<dx-toast [message]="notifyMessage" [type]="toastOption.type" [displayTime]="4000" [visible]="isNotifyVisible"
    (onHidden)="onResetNotify()">
    <dxo-position at="top right" my="top right" offset="-10 10"></dxo-position>
</dx-toast>